<template>
  <div style="width: 100%;">
    <div style="width: 100%;display: flex;flex-direction: column; justify-content: center;align-items: center;padding-top: 20px;">
      <my-text-one title="VR接入" :textContent="'VR接入教程'"></my-text-one>
      <div class="list-view" :style="{ height: screenHeight }">

        <div class="vr-card">
          <p class="vr-lead">这里的「接入 VR」不是做成专业沉浸式 VR 内容，而是把本软件里的平面画面投到 VR 设备屏幕上显示，通过 VR 接口完成联动。</p>
          <h3>使用前准备</h3>
          <ol>
            <li>准备一台支持投屏 / 镜像的 VR 头显（或配套的 VR 播放盒子）。</li>
            <li>确认头显与当前练习设备（手机 / 平板 / 电脑）在同一 Wi‑Fi，或已用数据线按厂商说明连接。</li>
            <li>打开本软件，进入需要展示的页面（如乐器练习、视频、乐声等）。</li>
          </ol>
          <h3>接入步骤</h3>
          <ol>
            <li>在 VR 设备中打开「投屏 / 镜像 / 浏览器投屏」类功能（名称以设备说明书为准）。</li>
            <li>选择当前正在运行本软件的设备进行配对；首次连接可能需要在两端确认授权。</li>
            <li>配对成功后，VR 屏幕会显示本软件的平面界面，即可在头显中观看与跟随。</li>
            <li>如画面倒置、黑屏或延迟过大，请断开后重新连接，或检查网络与设备电量。</li>
          </ol>
          <h3>说明</h3>
          <ul>
            <li>本入口提供的是接入教程与说明，不替代 VR 厂商自带的连接向导。</li>
            <li>不同品牌头显的菜单名称可能略有差异，请以设备官方教程为准。</li>
            <li>若课堂环境有固定 VR 套件，请先按老师或实验室提供的连接方式操作。</li>
          </ul>
        </div>

      </div>
      <div class="kuang">
        <div class="bubble" v-for="n in 10" :key="n"></div>
      </div>
    </div>
  </div>
</template>

<script>
import MyTextOne from '@/components/MyTextOne.vue'
export default {
  name: 'VrGuide',
  components: { MyTextOne },
  data () {
    return {
      screenHeight: (window.screen.height - 280) + 'px'
    }
  }
}
</script>

<style lang="less" scoped>
.list-view {
  width: 70%;
  margin-top: 24px;
  overflow-x: hidden;
  overflow-y: auto;
}
.list-view::-webkit-scrollbar {
  display: none;
}
.vr-card {
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6);
  backdrop-filter: blur(50px);
  border-radius: 12px;
  padding: 28px 32px 36px;
  color: #f2f7ff;
  line-height: 1.75;
  font-size: 16px;
}
.vr-lead {
  margin: 0 0 18px;
  font-size: 17px;
  color: #dff6ff;
}
.vr-card h3 {
  margin: 22px 0 10px;
  font-size: 18px;
  color: #9ee7ff;
}
.vr-card ol,
.vr-card ul {
  margin: 0;
  padding-left: 1.3em;
}
.vr-card li {
  margin: 8px 0;
}
.kuang {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));
}
.bubble {
  position: absolute;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: inset 0 0 8px #fff;
  animation: flutter 10s infinite;
  opacity: 0;
}
.bubble:nth-child(1) { width: 40px; height: 40px; left: 10%; animation-duration: 8s; }
.bubble:nth-child(2) { width: 25px; height: 25px; left: 25%; animation-duration: 10s; animation-delay: 1s; }
.bubble:nth-child(3) { width: 50px; height: 50px; left: 40%; animation-duration: 7s; animation-delay: 2s; }
.bubble:nth-child(4) { width: 18px; height: 18px; left: 55%; animation-duration: 9s; }
.bubble:nth-child(5) { width: 32px; height: 32px; left: 70%; animation-duration: 11s; animation-delay: 1.5s; }
.bubble:nth-child(6) { width: 22px; height: 22px; left: 82%; animation-duration: 8s; animation-delay: 3s; }
.bubble:nth-child(7) { width: 45px; height: 45px; left: 15%; animation-duration: 12s; animation-delay: 2.5s; }
.bubble:nth-child(8) { width: 28px; height: 28px; left: 48%; animation-duration: 9s; animation-delay: 0.5s; }
.bubble:nth-child(9) { width: 36px; height: 36px; left: 63%; animation-duration: 10s; animation-delay: 4s; }
.bubble:nth-child(10) { width: 20px; height: 20px; left: 90%; animation-duration: 7s; animation-delay: 1s; }
@keyframes flutter {
  0% { transform: translateX(0); bottom: -100px; opacity: 1; }
  50% { transform: translateX(60px); opacity: 0.7; }
  100% { transform: translateX(-40px); bottom: 110%; opacity: 0; }
}
</style>
